const debugLogs = false;

// Generate coupon code events programmatically
const couponCodes = ['LEVIS40', 'HURLEY40', 'CYBER20', 'ONLINE30', 'BLACKFRIDAY'];
const couponLocations = ['pdp', 'cart'];

const baseEvents = [
  ['.atcb-list-item', 'add_to_calendar'],
  ['.footer-nav-link', 'footer_link'],
  ['.releases-buy-now-btn', 'releases_buy_now_button'],
  ['#mobile-navigation .block-mobile-navigation:last-child #menu-level-2 .mobile-grandchild-link', 'mobile_nav_sale_link'],
  ['.centimeters-toggle', 'cm_size_guide_toggle'],
  ['.pdp-size-guide-accordion', 'pdp_size_guide_accordion'],
  ['.quickview-popup-button', 'plp_quickview_popup_button'],
  ['.quickview-atc-button', 'plp_quickview_atc_button'],
  ['.blog-post-click', 'blog_post_clicked'],
  ['.theme-template-article .section-rich-text a', 'link_in_blog_post_clicked'],
  ['.pdp-atc-tracking', 'footer_pdp_atc_tracking'],
  ['.sales-clothing-tab', 'sales_clothing_tab'],
  ['.mini-cart-product-add-on-click', 'mini_cart_product_add_on_click'],
  ['.mini-cart-product-add-on-plus-button-click', 'mini_cart_product_add_on_plus_button_click'],
  ['.mobile-nav-link', 'mobile_nav_link'],
  ['.desktop-nav-link', 'desktop_nav_link'],
];

// Generate coupon events
const couponEvents = couponLocations.flatMap(location =>
  couponCodes.map(code => [
    `.coupon-code-click-${location}-${code}`,
    `coupon_code_click_${location}_${code}`
  ])
);

const events = [...baseEvents, ...couponEvents];

// Pre-compile a map for faster lookup
const eventMap = new Map(events);

function getEventLabel(target, selector) {
  const href = target.getAttribute('href');
  if (href) return href;
  
  const text = target.innerText?.trim();
  return text === 'CHOOSE OPTIONS' ? selector : text || selector;
}

document.body.addEventListener('click', (event) => {
  // Early exit if target is disabled
  if (event.target.disabled || event.target.closest('[disabled]')) return;
  
  for (const [selector, category] of eventMap) {
    const target = event.target.closest(selector);
    
    if (target) {
      if (debugLogs) {
        console.log(`Clicked on: ${selector}, Category: ${category}`);
      }
      
      const label = getEventLabel(target, selector);
      
      Shopify.analytics.publish('clicked_rrs', {
        event_category: category,
        event_label: label,
        event_action: 'click',
      });
      
      break;
    }
  }
}, { passive: true }); // Add passive flag for better scroll performance